import React, { useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

/** Page-level action bar; sits at the bottom of the main content. */
const COPYRIGHT_FOOTER_HEIGHT = 0;

const getMainContentInset = () => {
  const main = document.querySelector('main');
  if (!main) {
    return { left: 0, right: 0 };
  }
  const rect = main.getBoundingClientRect();
  return {
    left: Math.max(0, rect.left),
    right: Math.max(0, window.innerWidth - rect.right),
  };
};

const insetsEqual = (a, b) =>
  a && b && a.left === b.left && a.right === b.right;

/** Page-level action bar; sits at the bottom of the main content. */
const AssignPrescriptionActionFooter = ({ children }) => {
  const [inset, setInset] = useState(getMainContentInset);

  useLayoutEffect(() => {
    const sync = () => {
      const next = getMainContentInset();
      setInset((prev) => (insetsEqual(prev, next) ? prev : next));
    };

    sync();
    window.addEventListener('resize', sync);

    const Observer = window.ResizeObserver;
    const observer = Observer ? new Observer(sync) : null;
    const main = document.querySelector('main');
    if (observer && main) observer.observe(main);

    return () => {
      window.removeEventListener('resize', sync);
      if (observer) observer.disconnect();
    };
  }, []);

  return (
    <Box
      className="react-no-print"
      component="footer"
      aria-label="Prescription actions"
      sx={{
        position: 'fixed',
        bottom: COPYRIGHT_FOOTER_HEIGHT,
        left: inset.left,
        right: inset.right,
        zIndex: 10000,
        boxSizing: 'border-box',
        px: { xs: 1, sm: 1.25 },
        py: { xs: 1, sm: 1.2 },
        borderTop: '1px solid #e2e8f0',
        borderRadius: 0,
        background: 'rgba(255, 255, 255, 0.92)',
        backdropFilter: 'blur(8px)',
        boxShadow: '0 -4px 20px rgba(15, 23, 42, 0.08)',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: { xs: 0.5, sm: 0.75 },
          justifyContent: 'flex-start',
          alignItems: 'center',
          alignContent: 'center',
          width: '100%',
          maxWidth: '100%',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

AssignPrescriptionActionFooter.propTypes = {
  children: PropTypes.node,
};

AssignPrescriptionActionFooter.defaultProps = {
  children: null,
};

export default AssignPrescriptionActionFooter;



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/AssignPrescriptionActionFooter.jsx